import type { FilterOption } from "./types"

/**
 * Strict filter function that only shows items containing the search term
 * Uses case-insensitive substring matching
 */
export const strictFilter = (value: string, search: string): number => {
  // If no search term, show all items
  if (!search) return 1

  // Only show items that contain the search term (case-insensitive)
  const searchLower = search.toLowerCase().trim()
  const valueLower = value.toLowerCase()

  return valueLower.includes(searchLower) ? 1 : 0
}

/**
 * Sorts options with selected items first, then alphabetically
 */
export const sortOptions = (
  options: FilterOption[],
  selectedValues: Set<string | null> | string | null,
): FilterOption[] => {
  return [...options].sort((a, b) => {
    const aSelected =
      selectedValues instanceof Set
        ? selectedValues.has(a.value)
        : selectedValues === a.value
    const bSelected =
      selectedValues instanceof Set
        ? selectedValues.has(b.value)
        : selectedValues === b.value

    // First: selected before unselected
    if (aSelected && !bSelected) return -1
    if (!aSelected && bSelected) return 1

    // Second: alphabetical order by label
    return a.label.localeCompare(b.label)
  })
}
